import React from "react";
import {Link} from "react-router-dom";
import { Button, Card, CardContent, Container, Grid, Typography } from "@material-ui/core";
import globalStyles from "../../../../theme/global.styles";
import useStyles from "../../Home.styles";
import CategoryListStyles from "./CategoryList.styles"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight, faCompassDrafting, faLaptopCode, faServer, faTruckPlane, faHeartPulse, faCouch, faCoins, faGasPump} from "@fortawesome/free-solid-svg-icons";
import CategoryPicker from "../CategoryPicker/CategoryPicker";

const categoryList = [
  {
    icon: faCompassDrafting,
    text: "Architekti a stavebně-technické služby",
    link: "/verejne-zakazky?phrase=%23architektistavba"
  },
  {
    icon: faServer,
    text: "IT technologie",
    link: "/verejne-zakazky?phrase=%23ittechnologie"
  },
  {
    icon: faLaptopCode,
    text: "Informační technologie - vývoj a služby",
    link: "/verejne-zakazky?phrase=%23vyvojit"
  },
  {
    icon: faTruckPlane,
    text: "Doprava a cestování",
    link: "/verejne-zakazky?phrase=%23dopravacestovani"
  },
  {
    icon: faHeartPulse,
    text: "Léky, léčiva, léčivé přípravky",
    link: "/verejne-zakazky?phrase=%23leky"
  },
  {
    icon: faCouch,
    text: "Nábytek",
    link: "/verejne-zakazky?phrase=%23nabytek"
  },
  {
    icon: faCoins,
    text: "Finance a pojištění",
    link: "/verejne-zakazky?phrase=%23financnipojisteni"
  },
  {
    icon: faGasPump,
    text: "Paliva a energie",
    link: "/verejne-zakazky?phrase=%23palivaenergie"
  }
]

console.log("categoryList", categoryList.map((item) => (item.text)))

const CategoryList: React.FC = () => {
  const globalClasses = globalStyles();
  const classes = useStyles();
  const categoryListClasses = CategoryListStyles();

  return (
      <div className={categoryListClasses.wrapper}>
        <Container maxWidth="lg">
          <h2 className={classes.hpTitle}>Kategorie veřejných zakázek</h2>

          <Grid container spacing={4}>
            {categoryList.map((item, i) => (
              <Grid key={i} item md={3} sm={6} xs={12}>
                <Link to={item.link} title={item.text}>
                  <Card className={categoryListClasses.card}>
                    <CardContent className={categoryListClasses.cardContent}>
                      <Typography variant="h3" className={categoryListClasses.title}>{item.text}</Typography>
                      <Button color={"primary"} className={globalClasses.btnTertiary + " " + categoryListClasses.linkText}>
                        Zobrazit více
                        <FontAwesomeIcon className={globalClasses.btnIcon} icon={faArrowRight}/>
                      </Button>
                    </CardContent>
                    <div className={categoryListClasses.iconWrapper}>
                      <FontAwesomeIcon className={categoryListClasses.categoryIcons} icon={item.icon}/>
                    </div>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>

          <CategoryPicker />

          <hr className={classes.hr}/>

        </Container>
      </div>
  )
}

export default CategoryList;
